export default "__VITE_ASSET__DVHE5oY9__"